import React, { useState, useEffect } from 'react'
import { Input, Form, Select, Button, DatePicker, Row, Col } from 'antd'
import * as API from '../../../../api'
import * as GLOBAL from '../../../../utils/global'

import './index.less'
const { Option } = Select
export interface ReptileSelectQuery {
	content?: string
	createrWorkid?: string
	name?: string
	orderBy?: string
}
export interface SearchProps {
	onSearch?: (val: ReptileSelectQuery) => void
	addMedia?: () => void
	btnAuth: string[]
	getInfoForm?: string
}

const NewMediaSearch: React.FC<SearchProps> = ({ onSearch, addMedia, btnAuth, getInfoForm }) => {
	const [form] = Form.useForm()
	const [typeList, setTypeList] = useState([])
	const [allChannel, setAllChannel] = useState([])
	const [channelAccount, setChannelAccount] = useState([])
	const [hotelCount, setHotelCount] = useState({
		todayPass: 0,
		todayReject: 0,
		weekPass: 0,
		weekReject: 0,
		savingMoney: 0,
	})

	const isMcn = () => {
		return location.hash.indexOf('newMediaMcn') > -1
	}
	const isVideo = () => {
		return location.hash.indexOf('newMediaVideo') > -1
	}
	const isNewMarket = () => {
		return location.hash.indexOf('newMarket') > -1
	}
	const getTypeList = async () => {
		// 内容形式
		const list = await GLOBAL.getContentType('list')
		setTypeList(list)
	}
	const getAllChannel = async () => {
		const { data } = await API.getAllChannel()
		setAllChannel(data)
	}
	const getChannelAccount = async value => {
		const { data } = await API.getChannelAccount({ channel: value })
		setChannelAccount(data)
		form.setFieldsValue({ outAccount: '' })
	}
	const selectHotelCount = async () => {
		const requestMethod = isMcn() || isVideo() ? API.selectHotelCountNew : API.selectHotelCount
		const data = await requestMethod(1)
		const result = isMcn()
			? {
					todayPass: data.result.todayCount,
					todayReject: data.result.todayNotCount,
					weekPass: data.result.weekCount,
					weekReject: data.result.weekNotCount,
					savingMoney: data.result.price,
			  }
			: isVideo()
			? {
					todayPass: data.result.todayCount,
					todayReject: data.result.todayNotCount,
					weekPass: data.result.weekCount,
					weekReject: data.result.weekNotCount,
					savingMoney: data.result.price,
					mcn: true,
			  }
			: data.data
		setHotelCount(result)
	}
	useEffect(() => {
		getTypeList()
		getAllChannel()
		selectHotelCount()
		form.setFieldsValue(JSON.parse(getInfoForm))
	}, [])
	const submit = () => {
		form
			.validateFields()
			.then(fieldsValue => {
				fieldsValue.beginUpdateTime =
					fieldsValue.beginUpdateTime &&
					fieldsValue.beginUpdateTime.format().split('T')[0] + ' ' + '00:00:00'
				fieldsValue.beginPublishTime =
					fieldsValue.beginPublishTime &&
					fieldsValue.beginPublishTime.format().split('T')[0] + ' ' + '00:00:00'
				!fieldsValue.beginPublishTime && delete fieldsValue.beginPublishTime
				!fieldsValue.beginUpdateTime && delete fieldsValue.beginUpdateTime
				onSearch && onSearch(fieldsValue)
			})
			.catch(err => {
				console.log(err)
			})
	}
	const reset = () => {
		form.setFieldsValue({
			beginPublishTime: null,
			beginUpdateTime: null,
			checkStatus: '',
			createTimeOrder: '',
			deptName: '',
			outAccount: '',
			outChannelCode: '',
			principalName: '',
			reason: '',
			title: '',
			type: '',
		})
	}

	const checkList = [
		{
			label: '系统审核中',
			value: '1',
		},
		{
			label: '系统未通过',
			value: '3',
		},
		{
			label: '法务待审核',
			value: '6',
		},
		{
			label: '法务已通过',
			value: '7',
		},
		{
			label: '法务未通过',
			value: '8',
		},
		{
			label: '已撤回',
			value: '11',
		},
	]
	const checkNode = checkList.map(item => {
		return (
			<Option key={item.label} value={item.value}>
				{item.label}
			</Option>
		)
	})
	return (
		<div className="new-media-search">
			<Row className="media-info">
				<Col span={4}>
					<div className="number pass">{hotelCount.todayPass}</div>
					<div className="describe">今日通过条数</div>
				</Col>
				<Col span={4}>
					<div className="number pass">{hotelCount.weekPass}</div>
					<div className="describe">本周通过条数</div>
				</Col>
				<Col span={4}>
					<div className="number not-pass">{hotelCount.todayReject}</div>
					<div className="describe">今日不合规条数</div>
				</Col>
				<Col span={6}>
					<div className="number not-pass">{hotelCount.weekReject}</div>
					<div className="describe">本周不合规条数</div>
				</Col>
				<Col span={3}>
					<div className="number">{hotelCount.savingMoney}W</div>
					<div className="describe">共计节省金额</div>
				</Col>
				<Col span={3}>
					{(isMcn() || isVideo() || isNewMarket()) && (
						<Button type="primary" onClick={addMedia}>
							上传内容
						</Button>
					)}
				</Col>
			</Row>
			<Form
				layout="inline"
				form={form}
				initialValues={{
					orderBy: '1',
				}}
			>
				<Form.Item name="title" label="标题" style={{ width: '148px' }}>
					<Input />
				</Form.Item>
				<Form.Item name="principalName" label="负责人" style={{ width: '148px' }}>
					<Input />
				</Form.Item>
				<Form.Item name="deptName" label="部门" style={{ width: '148px' }}>
					<Input />
				</Form.Item>
				<Form.Item name="reason" label="原因(敏感词)" style={{ width: '148px' }}>
					<Input />
				</Form.Item>
				<Form.Item name="type" label="内容形式" style={{ width: '148px' }}>
					<Select>
						<Select.Option value="" key="">
							请选择
						</Select.Option>
						{typeList.map(item => {
							return (
								<Select.Option value={item.id} key={item.id}>
									{item.name}
								</Select.Option>
							)
						})}
					</Select>
				</Form.Item>
				<Form.Item name="beginPublishTime" label="发布时间">
					<DatePicker />
				</Form.Item>
				<Form.Item name="beginUpdateTime" label="修改时间">
					<DatePicker />
				</Form.Item>
				{isVideo() ? null : (
					<>
						<Form.Item name="outChannelCode" label="渠道" style={{ width: '202px' }}>
							<Select onChange={getChannelAccount}>
								<Select.Option value="" key="">
									请选择
								</Select.Option>
								{allChannel.map(channel => {
									const { code, value } = channel
									return (
										<Select.Option key={code} value={code}>
											{value}
										</Select.Option>
									)
								})}
							</Select>
						</Form.Item>
						<Form.Item name="outAccount" label="" colon={false} style={{ width: '230px' }}>
							<Select>
								<Select.Option value="" key="">
									请选择
								</Select.Option>
								{channelAccount.map(account => {
									const { id, st_out_account_name } = account
									return (
										<Select.Option key={id + 'outAccount'} value={st_out_account_name}>
											{st_out_account_name}
										</Select.Option>
									)
								})}
							</Select>
						</Form.Item>
					</>
				)}
				{/* <Form.Item name="h" label="是否过法务" style={{ width: '140px' }}>
					<Select>
						<Select.Option value="0">长图文</Select.Option>
						<Select.Option value="1">文件</Select.Option>
					</Select>
				</Form.Item> */}
				<Form.Item name="checkStatus" label="审核状态" style={{ width: '200px' }}>
					<Select>
						<Option key="全部" value="">
							全部
						</Option>
						{checkNode}
					</Select>
				</Form.Item>
				<Form.Item name="createTimeOrder" label=" " colon={false} style={{ width: '160px' }}>
					<Select>
						<Select.Option value="">请选择</Select.Option>
						<Select.Option value="1">按创建时间倒序</Select.Option>
						<Select.Option value="0">按创建时间升序</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item>
					<Button type="primary" onClick={submit}>
						搜索
					</Button>
					<Button type="primary" onClick={reset} style={{ margin: '0 0 0 20px' }}>
						重置
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}
export default NewMediaSearch
